import { ActionEnum } from "../action.enum";
import { InvoiceModel } from "../../models/invoice/invoice.model";
import { DocumentModel } from "../../models/document/document.model";

export namespace InvoiceDialogAction {

  export class Create {
    static readonly type: ActionEnum = ActionEnum.INVOICE_DIALOG_CREATE_INVOICE;

    constructor(public preselectedObjectId: string, public preselectedComponentClassId: string) {}
  }

  export class Edit {
    static readonly type: ActionEnum = ActionEnum.INVOICE_DIALOG_EDIT_INVOICE;

    constructor(
      public invoiceId: string,
      public preselectedObjectId: string,
      public preselectedComponentClassId: string
    ) {}
  }

  export class AddAttachment {
    static readonly type: ActionEnum = ActionEnum.INVOICE_DIALOG_ADD_ATTACHMENT;

    constructor(public document: DocumentModel) {}
  }

  export class DeleteAttachment {
    static readonly type: ActionEnum = ActionEnum.INVOICE_DIALOG_DELETE_ATTACHMENT;

    constructor(public documentDataId: string) {}
  }

  export class UpdateInvoice {
    static readonly type: ActionEnum = ActionEnum.INVOICE_DIALOG_UPDATE_INVOICE;

    constructor(public invoice: InvoiceModel) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.INVOICE_DIALOG_SAVE;
  }

  export class Delete {
    static readonly type: ActionEnum = ActionEnum.INVOICE_DIALOG_DELETE;
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.INVOICE_DIALOG_RESET_STATE;
  }

  export class ExtractPositionWithAI {
    static readonly type: ActionEnum = ActionEnum.INVOICE_EXTRACT_POSITION_WITH_AI;
  }
}
